// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-scrollnum{overflow:hidden;position:absolute;left:50%;top:0;transform:translateX(-50%)}.v5-scrollnum-item{position:absolute;transition:all .6s}.v5-scrollnum-item .v5-scrollnum-ten{display:block;text-align:center}", ""]);
// Exports
module.exports = exports;
